// src/App.js
import React from 'react';
import { useSelector } from 'react-redux';
import { StyledEngineProvider, CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/styles';
import { BrowserRouter } from 'react-router-dom';

import Routes from './routes';              // ← should now export MainRoutes
import { createAppTheme } from './themes';
import NavigationScroll from './layout/NavigationScroll';
import ChatWidget from './components/ChatWidget';

import './App.css';
import './styles/mobile.css';
import './insight-hub.css';

const App = () => {
  const customization = useSelector((state) => state.customization);
  const isLoggedIn     = useSelector((state) => state.account.isLoggedIn);
  const theme          = createAppTheme(customization);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />

        {/* ← Wrap your entire routing tree in BrowserRouter */}
        <BrowserRouter>
          <NavigationScroll>
            <Routes />
          </NavigationScroll>
        </BrowserRouter>

        {/* ← Your ChatWidget overlay (only when logged in) */}
        {isLoggedIn && <ChatWidget />}
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
